/** Account Wi-Fi vault (docs/WIFI-NETWORKS.md). The server never returns a password. */
export interface WifiNetwork {
  id: string;
  ssid: string;
  priority: number;
  shared: boolean;
  origin: string | null;
  hasPassword: true;
  revision: number;
  createdAt: number;
  updatedAt: number;
  lastUsedAt: number | null;
}
export interface WifiNetworkList { networks: WifiNetwork[]; revision: number }
export interface WifiNetworkCreate { ssid: string; psk: string; origin?: string; shared?: boolean }
/** At least one field besides `expectedRevision`; `origin: null` clears the label. */
export interface WifiNetworkPatch { priority?: number; shared?: boolean; origin?: string | null; psk?: string }

export const WIFI_VAULT_LIMIT = 10;
/** Most networks one envelope may carry (docs/WIRELESS-PAIRING.md, protocol v2). */
export const MAX_ENVELOPE_NETWORKS = 5;
export const ORIGIN_THIS_MAC = 'Este Mac';
export const ORIGIN_MANUAL = 'Manual';

export type MacWifiErrorCode = 'unsupported' | 'denied' | 'not_found' | 'timeout' | 'unsupported_key' | 'failed' | 'busy' | 'invalid_ssid' | 'not_allowed';
export type MacWifiResult<T> = ({ ok: true } & T) | { ok: false; code: MacWifiErrorCode; message: string };
/** `window.asisDesktop.wifi`: only the Mac app has it, and every call must come from a click. */
export interface MacWifiBridge {
  listSaved(): Promise<MacWifiResult<{ ssids: string[] }>>;
  readPassword(ssid: string): Promise<MacWifiResult<{ psk: string }>>;
  cancel(): Promise<void>;
}
